import { SpinnerIcon } from './SpinnerIcon';
import { cn } from '../../lib/utils';
import { useSkeletonAppearance } from '../../hooks/useSkeletonAppearance';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

/**
 * A spinner for a process with no content shape to hold (a redirect, a server-side check).
 * A read gets a skeleton instead: `apps/web/bill/src/components/ui/CLAUDE.md` § "Loading".
 * Shares the skeleton's appearance (`useSkeletonAppearance`), so a quick process never flashes it.
 */
export function LoadingState({ message = 'Loading...', className }: LoadingStateProps) {
  const appearance = useSkeletonAppearance<HTMLDivElement>();
  return (
    <div
      ref={appearance.ref}
      className={cn(appearance.className, 'flex h-64 flex-col items-center justify-center gap-3', className)}
      style={appearance.style}
      role="status"
      aria-live="polite"
    >
      <SpinnerIcon className="h-5 w-5 text-text-muted" />
      <span className="text-sm text-text-muted">{message}</span>
    </div>
  );
}
